import React from 'react';
import { Eyebrow } from './Eyebrow';
export function WhyExistsSection() {
  return <section className="bg-carbon-card py-14 md:py-20" aria-labelledby="why-title" data-id="element-257" data-mp="1ec3jwdlzy2j5">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-258" data-mp="1jbpv6hi9l8pb">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-259" data-mp="1ja52kxfifzu3">
          <Eyebrow tone="dark" data-id="element-260" data-mp="1o2enfz1rq9pi">Por qué existe</Eyebrow>
          <h2 id="why-title" className="mt-4 text-[26px] leading-[1.15] text-ink-light sm:text-[34px] lg:text-[38px]" data-id="element-261" data-mp="1o3zjxu7n82q0">
            Hombre Magnético nació de un problema que se repite demasiado
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-[560px] rounded-[14px] border border-white/10 bg-white/[0.04] p-5 md:p-7" data-id="element-262" data-mp="222z5gszv01hy">
          <div className="space-y-4 text-[12px] font-medium leading-relaxed text-ink-light/70 md:text-[13px]" data-id="element-263" data-mp="270ios7bez4gr">
            <p data-id="element-264" data-mp="7pzn4s43gt6z">
              Muchos hombres pueden conocer mujeres y conversar con ellas.
              Consiguen confianza, cercanía y conversaciones profundas. Pero una
              y otra vez aparece el mismo patrón: ella se siente cómoda, cuenta
              todo… y la atracción nunca termina de avanzar.
            </p>
            <p data-id="element-265" data-mp="1sujbd9pam6y5">
              Información no falta. Hay miles de vídeos, consejos, frases y
              técnicas sobre qué decir, cuándo escribir o cómo comportarse.{' '}
              <span className="font-bold text-ink-light" data-id="element-266" data-mp="1ntmy45j1x8g2">
                El problema puede ser justamente ese: demasiadas piezas sueltas
                y ninguna estructura.
              </span>
            </p>
            <p data-id="element-267" data-mp="2gikajs0l0b0w">
              Hombre Magnético reúne esas piezas en un único recorrido:
              seguridad, conversación, señales de interés, intención, mensajes,
              citas y relaciones.
            </p>
            <p data-id="element-268" data-mp="105vh4omkg78g">
              No para interpretar un personaje. No para controlar a otra
              persona. Para comprender mejor qué comunicas y construir
              conexiones con mayor claridad e intención.
            </p>
          </div>

          <p className="mt-6 border-t border-white/10 pt-5 text-[14px] font-extrabold tracking-[-0.01em] text-gold-light md:text-[15px]" data-id="element-269" data-mp="xm8qtlgkkj04">
            Menos confusión. Más seguridad, presencia e intención.
          </p>
        </div>
      </div>
    </section>;
}